import { useState, useEffect } from 'react';
import { STORE_LOGOS } from '../services/storeLogos';

interface StoreLogoProps {
  storeId: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showBrandColors?: boolean;
}

const StoreLogoComponent = ({ 
  storeId, 
  size = 'md', 
  className = '', 
  showBrandColors = false 
}: StoreLogoProps) => {
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);
  const [logoFailed, setLogoFailed] = useState(false);
  
  const storeData = STORE_LOGOS[storeId];
  
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8', 
    lg: 'w-12 h-12'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl'
  };

  useEffect(() => {
    setCurrentLogoIndex(0);
    setLogoFailed(false);
  }, [storeId]);

  if (!storeData) {
    return (
      <div className={`${sizeClasses[size]} bg-gray-500 rounded-full flex items-center justify-center ${className}`}>
        <span className={`${textSizes[size]} text-white`}>🏪</span>
      </div>
    );
  }

  const handleImageError = () => {
    const allLogos = [storeData.primaryLogo, ...storeData.fallbackLogos].filter(Boolean);
    
    if (currentLogoIndex < allLogos.length - 1) {
      setCurrentLogoIndex(prev => prev + 1);
    } else {
      setLogoFailed(true);
    }
  };

  const getCurrentLogo = () => {
    const allLogos = [storeData.primaryLogo, ...storeData.fallbackLogos].filter(Boolean);
    return allLogos[currentLogoIndex];
  };

  const currentLogo = getCurrentLogo();
  const shouldShowImage = currentLogo && !logoFailed;
  
  const containerStyle = showBrandColors ? {
    backgroundColor: storeData.brandColors.primary,
    color: storeData.brandColors.secondary
  } : {};

  return (
    <div 
      className={`${sizeClasses[size]} ${showBrandColors ? '' : 'bg-white border'} rounded-full flex items-center justify-center ${className}`}
      style={containerStyle}
    >
      {shouldShowImage ? (
        <img 
          src={currentLogo}
          alt={storeData.name}
          className={`${size === 'lg' ? 'w-8 h-8' : size === 'md' ? 'w-6 h-6' : 'w-4 h-4'} object-contain`}
          onError={handleImageError}
        />
      ) : (
        <span className={`${textSizes[size]} ${showBrandColors ? '' : 'text-gray-600'}`}>
          {storeData.emoji}
        </span>
      )}
    </div>
  );
};

export default StoreLogoComponent;